import { Link } from "react-router-dom";

const features = [
  {
    title: "Verified Links",
    description: "Every link in our superbuy spreadsheet is manually checked and verified. No dead ends, no broken redirects — just reliable shopping links that work.",
    image: "https://readdy.ai/api/search-image?query=Modern%20clean%20desktop%20workspace%20with%20open%20laptop%20showing%20organized%20spreadsheet%20interface%20neat%20desk%20arrangement%20with%20ceramic%20coffee%20cup%20and%20small%20greenery%20natural%20daylight%20from%20window%20creating%20fresh%20bright%20atmosphere%20editorial%20tech%20photography%20warm%20natural%20tones%20organized%20productive%20aesthetic%20contemporary%20home%20office%20style%20minimal%20composition&width=800&height=600&seq=feature-links-v2&orientation=landscape",
    icon: "ri-shield-check-line",
  },
  {
    title: "QC Ready",
    description: "Our superbuy spreadsheet includes QC tips and photo references so you know exactly what to look for before making a purchase. Shop with confidence.",
    image: "https://readdy.ai/api/search-image?query=Quality%20control%20inspection%20scene%20showing%20clothing%20items%20being%20carefully%20examined%20on%20clean%20light%20oak%20table%20with%20magnifying%20glass%20and%20measurement%20tools%20nearby%20soft%20natural%20window%20lighting%20editorial%20product%20photography%20clean%20organized%20composition%20warm%20neutral%20aesthetic%20professional%20yet%20approachable%20factory%20inspection%20style%20with%20white%20gloves%20and%20checklist%20visible&width=800&height=600&seq=feature-qc-v2&orientation=landscape",
    icon: "ri-search-eye-line",
  },
  {
    title: "Updated Daily",
    description: "The superbuy spreadsheet is refreshed every single day with new links, updated prices, and fresh categories. Never miss out on the latest drops.",
    image: "https://readdy.ai/api/search-image?query=Wall%20calendar%20with%20marked%20dates%20surrounded%20by%20fashion%20lookbook%20pages%20and%20fabric%20swatches%20on%20warm%20cream%20desk%20surface%20with%20aromatic%20coffee%20nearby%20soft%20morning%20light%20streaming%20in%20editorial%20photography%20creative%20organized%20composition%20fresh%20daily%20routine%20aesthetic%20lifestyle%20workspace%20style%20inspiring%20productive%20atmosphere%20neutral%20earthy%20tones&width=800&height=600&seq=feature-update-v2&orientation=landscape",
    icon: "ri-refresh-line",
  },
];

export default function FeatureGrid() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-12">
          <div className="lg:w-5/12">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Everything You<br />Need to Know
            </h2>
          </div>
          <div className="lg:w-7/12">
            <p className="text-sm text-foreground-600 leading-relaxed max-w-lg">
              The superbuy spreadsheet link directory is designed to make your shopping experience seamless. Verified links, QC guides, and daily updates — all in one place.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70 group hover:border-accent-200 transition-all duration-300"
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={feature.image}
                  alt={`Superbuy Spreadsheet ${feature.title}`}
                  title={`Superbuy Spreadsheet - ${feature.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className={`${feature.icon} text-accent-600 text-lg`}></i>
                  </span>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
                    {feature.title}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/articles/best-superbuy-spreadsheet-2026"
            className="inline-flex items-center gap-2 text-sm font-medium text-accent-700 hover:text-accent-800 transition-colors cursor-pointer"
          >
            Learn more about our superbuy spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}